import classNames from "@src/utilities/class-names"

export interface ProductHeaderProductLinksProps {
  currentSlug: string
  header?: string
  links?: {
    _uid: string
    icon_selected?: {
      filename?: string
    }
    icon_unselected?: {
      filename?: string
    }
    product_link?: {
      cached_url?: string
      url?: string
    }
  }[]
}

export default function ProductHeaderProductLinks({
  currentSlug,
  header,
  links,
}: ProductHeaderProductLinksProps) {
  return (
    <div className="my-4" data-component="product-header-links">
      {header && header.trim().length > 0 && (
        <h6
          className="font-sans text-sm tracking-wide font-extrabold mb-2"
          dangerouslySetInnerHTML={{
            __html: header!,
          }}
        />
      )}
      <div>
        {links &&
          links.map((link, idx) => (
            <a
              className={classNames(
                "h-12 w-12 inline-block",
                idx === 0 ? "" : "ml-2"
              )}
              key={link._uid}
              href={`/${link.product_link?.cached_url}`}
            >
              <img
                className="block h-12 w-12"
                src={
                  currentSlug === link.product_link?.cached_url
                    ? link.icon_selected?.filename
                    : link.icon_unselected?.filename
                }
              />
            </a>
          ))}
      </div>
    </div>
  )
}
